import React from 'react'

const s = {
  overlay: { 
    position: 'fixed', 
    top: 0, 
    left: 0, 
    width: '100%', 
    height: '100%', 
    backgroundColor: 'rgba(0, 0, 0, 0.7)', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    zIndex: 1000 
  },
  modal: { 
    backgroundColor: '#1e293b', 
    borderRadius: '12px', 
    padding: '32px', 
    border: '1px solid #334155', 
    maxWidth: '450px', 
    width: '90%', 
    textAlign: 'center' 
  },
  title: { 
    fontSize: '24px', 
    fontWeight: '600', 
    margin: '0 0 16px 0', 
    color: '#f1f5f9' 
  },
  message: { 
    fontSize: '16px', 
    color: '#94a3b8', 
    margin: '0 0 32px 0', 
    lineHeight: '1.5' 
  },
  btnPrimary: { 
    padding: '12px 32px', 
    backgroundColor: '#2563eb', 
    color: 'white', 
    borderRadius: '8px', 
    border: 'none', 
    cursor: 'pointer', 
    fontSize: '16px',
    fontWeight: '600',
    marginBottom: '12px',
    width: '100%'
  },
  btnSecondary: { 
    backgroundColor: 'transparent', 
    border: '1px solid #475569', 
    color: '#94a3b8', 
    fontSize: '14px', 
    cursor: 'pointer', 
    padding: '8px 16px',
    borderRadius: '6px'
  }
}

export default function SimpleUpgradePrompt({ onClose, onViewPlans }) {
  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.modal} onClick={(e) => e.stopPropagation()}>
        <h2 style={s.title}>Premium Subscription Required</h2>
        <p style={s.message}>
          You need a premium subscription to access this feature. 
          View our plans to unlock all the tools you need to beat the bookmakers.
        </p>
        
        <button 
          style={s.btnPrimary}
          onClick={onViewPlans}
        >
          View Plans & Pricing
        </button>
        
        <div>
          <button onClick={onClose} style={s.btnSecondary}>
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  )
}